var login = {
  translation: {
    common: {
      accept: 'Aceptar',
      alreadyUser: '¿Ya eres usuario?',
      and: 'y',
      backToLogin: 'Volver a la página de inicio de sesión',
      continueWith: 'Continuar con {{provider}}',
      createAccount: 'Crear una cuenta',
      createYourAccount: 'Crea tu cuenta',
      emailOrUsername: 'Correo electrónico o nombre de usuario',
      login: 'Iniciar sesión',
      logInToBoards: 'Iniciar sesión',
      newToBoards: '¿Nuevo en RICE-WORK?',
      pageNotFound_title: 'Página no encontrada',
      password: 'Contraseña',
      privacyPolicy: 'Política de Privacidad',
      register: 'Registrarse',
      registerWithGoogle: 'Registrarse con Google',
      termsOfService: 'Términos de Servicio',
      togglePasswordVisibility: 'Mostrar u ocultar contraseña',
    },

    action: {
      logIn: 'Iniciar sesión',
    },
  },
};

export { login as default };
